(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mr-pp-menu-section"] && !Shopify.designMode) return;
  try {
    
    const dropMenuCheckbox = document.getElementById('drop-menu-checkbox');
    const dropMenuCheckboxSmallMobile = document.getElementById('drop-menu-checkbox-small-mobile');
    const mobileDropMenu = document.getElementById('mobile-ul');
    const downChevron = document.getElementById('down-chev');
    const upChevron = document.getElementById('up-chev');
    const downChevronSmallMobile = document.getElementById('down-chev-small-mobile');
    const upChevronSmallMobile = document.getElementById('up-chev-small-mobile');
    const menuLinks = document.querySelectorAll('.rr-breadcrumb-navigation a');
    const mobileBottomBorder = document.getElementById('mobile-bottom-border');

    function toggleMainCheckbox() {
        if (dropMenuCheckboxSmallMobile.checked) {
            dropMenuCheckbox.checked = true;
        } else {
            dropMenuCheckbox.checked = false;
        }
        toggleMobileMenu();
    }

    function toggleMobileMenu() {
        if (dropMenuCheckbox.checked) {
            mobileDropMenu.style.display = "flex";
            upChevron.style.display = "flex";
            downChevron.style.display = "none";
            upChevronSmallMobile.style.display = "flex";
            downChevronSmallMobile.style.display = "none";
        } else {
            mobileDropMenu.style.display = "none";
            upChevron.style.display = "none";
            downChevron.style.display = "flex";
            upChevronSmallMobile.style.display = "none";
            downChevronSmallMobile.style.display = "flex";
        }
    }

    function closeMenuOnResize() {
        dropMenuCheckbox.checked = false;
        dropMenuCheckboxSmallMobile.checked = false;
        toggleMobileMenu();
    }
    window.addEventListener('resize', closeMenuOnResize);

    dropMenuCheckbox.addEventListener('change', toggleMobileMenu);
    dropMenuCheckboxSmallMobile.addEventListener('change', toggleMainCheckbox);

    toggleMobileMenu();

    function closeMenuOnLinkClick() {
            dropMenuCheckbox.checked = false;
            dropMenuCheckboxSmallMobile.checked = false;
            mobileDropMenu.style.display = "none";
            upChevron.style.display = "none";
            downChevron.style.display = "flex";
            toggleMobileMenu();
        }

    menuLinks.forEach(function (link) {
        link.addEventListener('click', closeMenuOnLinkClick);
    });

    document.addEventListener("DOMContentLoaded", function() {
    var siteHeaderMain = document.querySelector('.site-header-main');
    var menuArea = document.querySelector('.mr-pp-menu-area');

    function updateMenuTop() {
        if (siteHeaderMain && menuArea) {
            var headerHeight = siteHeaderMain.offsetHeight;
            menuArea.style.top = headerHeight + "px";
        }
    }

    updateMenuTop();

    window.addEventListener('scroll', updateMenuTop);
    window.addEventListener('resize', updateMenuTop);
    });

    //Price formatter
    function formatPrice(price) {
        const currencySymbols = {
            USD: '$',
            EUR: '€',
            GBP: '£'
        };

        const currencySymbol = currencySymbols[defaultCurrency] || '';
        let formattedPrice = Shopify.formatMoney(price).replace('$', '');
        
        return `${currencySymbol}${formattedPrice}`;
    }

    // Function to update product info
    function updateProductInfo(title, price, comparePrice) {
        const savedAmount = comparePrice - price;

        document.querySelectorAll('.rr-variant-title').forEach(element => element.innerText = title);
        document.querySelectorAll('.rr-product-price').forEach(element => element.innerText = formatPrice(price));
        document.querySelectorAll('.rr-was-price').forEach(element => element.innerText = formatPrice(comparePrice));
        document.querySelectorAll('.rr-money-saved').forEach(element => element.innerText = `Save ${formatPrice(savedAmount)}`);
        
        const showCompare = formatPrice(comparePrice) > formatPrice(price);
        document.querySelectorAll('.rr-was-price, .rr-money-saved').forEach(element => {
            element.style.display = showCompare ? "block" : "none";
        });
    }

    // Event handler for button clicks
    const VariantButton = document.querySelectorAll('.variant-button')
    if (VariantButton) {
        VariantButton.forEach(button => {
            button.addEventListener('click', function () {
                updateProductInfo(
                    this.getAttribute('data-title'),
                    parseFloat(this.getAttribute('data-price')),
                    parseFloat(this.getAttribute('data-compare-at-price'))
                );
            });
        });
    }

    // Event handler for select change
    const VariantSelector = document.getElementById('variant-selector')
    if (VariantSelector) {
        VariantSelector.addEventListener('change', function () {
            const selectedOption = this.options[this.selectedIndex];
            updateProductInfo(
                selectedOption.getAttribute('data-title'),
                parseFloat(selectedOption.getAttribute('data-price')),
                parseFloat(selectedOption.getAttribute('data-compare-at-price'))
            );
        });
    }
    
  } catch(e) { console.error(e); }
})();
})();
